import { useTranslation } from 'react-i18next';
import LoadingDots from '@/components/common/LoadingDots';
import MarkdownRenderer from '@/components/common/MarkdownRenderer';
import Section from '@/components/common/Section';

interface InsightSectionProps {
    isLite: boolean;
    content: string;
    loading?: boolean;
    hasError?: boolean;
}

const InsightSection = ({ isLite, content, loading, hasError }: InsightSectionProps) => {
    const { t } = useTranslation(['overallTraineeReport']);
    const title = isLite ? t('liteReport.sections.summary.title') : t('sections.trainerNotes.title');

    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center gap-1 rounded-[10px] bg-neutral-50 p-5">
                <LoadingDots />
                <p className="text-base leading-6 font-medium text-neutral-500">
                    {t('liteReport.sections.summary.loading')}
                </p>
            </div>
        );
    }

    if (hasError && !content) {
        return (
            <Section title={title} accent="muted">
                <p className="text-sm text-neutral-500">{t('liteReport.sections.summary.error')}</p>
            </Section>
        );
    }

    if (!content) {
        return null;
    }

    return (
        <Section title={title} accent="muted">
            <MarkdownRenderer content={content} />
        </Section>
    );
};

export default InsightSection;
